const es = {
  // App
  appName: 'InsTask',

  // Auth
  signIn: 'Iniciar sesión',
  signInSubtitle: 'Ingresa a tu cuenta',
  signInInstanceSubtitle: 'Ingresa con tu cuenta de Instance',
  signInWithInstance: 'Ingresar con tu cuenta de Instance',
  backToTraditionalLogin: 'Volver al login tradicional',
  signingIn: 'Ingresando...',
  passwordRequired: 'Ingresa tu contraseña',
  email: 'Correo electrónico',
  password: 'Contraseña',
  loginFailed: 'Error al iniciar sesión',
  invalidEmail: 'Ingresa un correo válido',
  passwordMinLength: 'La contraseña debe tener al menos 8 caracteres',
  invalidCredentials: 'Correo o contraseña incorrectos',

  // Sidebar
  dashboard: 'Panel',
  publications: 'Publicaciones',
  pauseEvents: 'Eventos de pausa',
  pausedPublications: 'Pub. Pausadas',
  pricingBuyBox: 'BuyBox',
  metrics: 'Métricas',
  pricingApprovals: 'Aprobaciones',
  internalTickets: 'Tickets',
  tasks: 'Tasks',
  publicationQuality: 'Calidad',
  admin: 'Administración',
  actionLog: 'Registro de acciones',
  logout: 'Cerrar sesión',

  // Dashboard
  dashboardTitle: 'Panel',
  dashboardSubtitle: 'Resumen de la automatización de publicaciones',
  total: 'Total',
  active: 'Activas',
  paused: 'Pausadas',
  openEvents: 'Eventos abiertos',
  resolved: 'Resueltos',
  actionsByStatus: 'Acciones por estado',
  actionsByType: 'Acciones por tipo',
  byClient: 'Por cliente',
  noActionsYet: 'Sin acciones aún',
  noPublicationsYet: 'Sin publicaciones aún',
  executed: 'ejecutada',
  failed: 'fallida',
  pending: 'pendiente',
  reprice: 'repricing',
  ticket: 'ticket',
  unknown: 'Desconocido',

  // Publications
  publicationsTitle: 'Publicaciones',
  newPublication: 'Nueva publicación',
  editPublication: 'Editar publicación',
  deletePublication: 'Eliminar publicación',
  status: 'Estado',
  all: 'Todas',
  title: 'Título',
  externalId: 'ID externo',
  price: 'Precio',
  category: 'Categoría',
  updated: 'Actualizado',
  actions: 'Acciones',
  noPublicationsFound: 'No se encontraron publicaciones',
  noResults: 'Sin resultados',

  // Forms
  save: 'Guardar',
  saving: 'Guardando...',
  cancel: 'Cancelar',
  delete: 'Eliminar',
  deleting: 'Eliminando...',
  dismiss: 'Descartar',
  clientId: 'ID de cliente',
  failedToSave: 'Error al guardar',
  failedToDelete: 'Error al eliminar',
  failedToLoad: 'Error al cargar',
  deleteConfirm: '¿Estás seguro de que deseas eliminar',
  deleteWarning: 'Esta acción no se puede deshacer.',

  // Pagination
  of: 'de',
  page: 'Página',
  prev: 'Anterior',
  next: 'Siguiente',

  // Pause Events
  pauseEventsTitle: 'Eventos de pausa',
  detectedAt: 'Detectado',
  resolvedAt: 'Resuelto',
  reason: 'Razón',
  publication: 'Publicación',
  open: 'abierto',
  resolved2: 'resuelto',
  noPauseEventsFound: 'No se encontraron eventos de pausa',
  dateFrom: 'Desde',
  dateTo: 'Hasta',
  filter: 'Filtrar',

  // Action Log
  actionLogTitle: 'Registro de acciones',
  actionType: 'Tipo',
  executedAt: 'Ejecutado',
  rule: 'Regla',
  noActionsFound: 'No se encontraron acciones',

  // Publication Detail
  publicationDetail: 'Detalle de publicación',
  priceHistory: 'Historial de precios',
  relatedActions: 'Acciones relacionadas',
  back: 'Volver',
  notFound: 'No encontrado',
  publicationNotFound: 'La publicación no existe',
  client: 'Cliente',
  permalink: 'Enlace',
  viewLink: 'Ver publicación',
  lastChecked: 'Última revisión',
  created: 'Creado',
  noPriceHistory: 'Sin historial de precios',

  // Paused Publications (Track 1)
  pausedPublicationsTitle: 'Publicaciones Pausadas',
  pausedPublicationsSubtitle: 'Publicaciones pausadas pendientes de gestión',
  selectCause: 'Seleccionar causa...',
  causeImageIssues: 'Problemas de imagen',
  causeWrongCategory: 'Categoría incorrecta',
  causeBrandAuth: 'Autorización de marca',
  causeDescriptionIssue: 'Problema de descripción',
  causeCompetitionBlock: 'Bloqueo por competencia',
  causePhotoLabels: 'Fotos con etiquetas',
  causeOther: 'Otro',
  generateTicket: 'Generar Ticket',
  generatingTicket: 'Generando...',
  ticketGenerated: 'Ticket generado',
  ticketGenerationFailed: 'Error al generar ticket',
  noPausedPublications: 'No hay publicaciones pausadas',
  cause: 'Causa',

  // Pricing / Buy Box (Track 2)
  pricingTitle: 'Precios / Buy Box',
  pricingSubtitle: 'Reglas de precio configurables por cliente',
  pricingRules: 'Reglas de precios',
  newRule: 'Nueva regla',
  editRule: 'Editar regla',
  deleteRule: 'Eliminar regla',
  ruleName: 'Nombre',
  ruleClient: 'Cliente',
  globalRule: 'Global',
  discountPercentage: '% de descuento',
  minimumPrice: 'Precio mínimo',
  ruleType: 'Tipo de regla',
  ruleTypeDiscount: 'Porcentaje de descuento',
  ruleTypeMinPrice: 'Precio mínimo por listado',
  ruleValue: 'Valor',
  priority: 'Prioridad',
  isActive: 'Activo',
  noRulesFound: 'No se encontraron reglas',
  deleteRuleConfirm: '¿Estás seguro de que deseas eliminar esta regla?',

  // Quality (Track 3)
  qualityTitle: 'Calidad de Publicación',
  qualitySubtitle: 'Monitoreo de salud de publicaciones',
  qualityComingSoon: 'Pendiente de integración con el canal',
  qualityDescription:
    'Esta sección mostrará la nota de calidad de cada publicación y generará tickets automáticos al equipo de catálogo cuando se detecten publicaciones con baja calidad.',
  qualityScore: 'Nota',
  qualityLevel: 'Nivel',
  qualityGood: 'Buena',
  qualityRegular: 'Regular',
  qualityBad: 'Mala',
  qualitySuggestions: 'Sugerencias',
  noSuggestions: 'Sin sugerencias',
  qualityHighPriority: 'Alta',
  qualityMediumPriority: 'Media',
  qualityLowPriority: 'Baja',
  qualitySummary: 'Resumen de calidad',
  qualityGoodCount: 'Buena calidad',
  qualityRegularCount: 'Regular',
  qualityBadCount: 'Requiere atención',

  // Dashboard tracks
  dashboardOverview: 'Resumen general',
  trackPausadas: 'Publicaciones Pausadas',
  trackPausadasDesc: 'Publicaciones detenidas pendientes de gestión',
  trackPrecios: 'Precios / Buy Box',
  trackPreciosDesc: 'Ajustes de precio y competitividad',
  trackCalidad: 'Calidad de Publicación',
  trackCalidadDesc: 'Monitoreo de salud de publicaciones',
  ticketsGenerated: 'Tickets generados',
  repriceActions: 'Cambios de precio',
  pendingReview: 'Pendientes de revisión',
  successRate: 'Tasa de éxito',
  goToSection: 'Ir a sección',
  pendingIntegration: 'Pendiente de integración',

  // Misc
  loading: 'Cargando...',
  error: 'Error',
  required: 'obligatorio',
} as const;

export type TranslationKey = keyof typeof es;

export function t(key: TranslationKey): string {
  return es[key];
}
